export default "/_nuxt/8c723b3c944709bb053dc4ce74d6c076.svg";